import { Injectable } from "@angular/core";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { CommonModalComponent } from "./common-modal.component";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";

@Injectable({
  providedIn: "root",
})
export class CommonModalService {
  constructor(private modalService: NzModalService) {}

  create = (modalParams: ModalParams): NzModalRef => {
    const positionStyle = modalParams.position && {
      position: "absolute",
      left: `${modalParams.position.left || 0}px`,
      top: `${modalParams.position.top || 0}px`,
      right: `${modalParams.position.right || 0}px`,
      bottom: `${modalParams.position.bottom || 0}px`,
    };

    const modal = this.modalService.create({
      nzWrapClassName: "vertical-center-modal",
      nzContent: CommonModalComponent,
      nzFooter: null,
      nzClosable: false,
      nzWidth: modalParams.body ? 500 : 300,
      nzBodyStyle: { padding: "24px" },
      nzComponentParams: modalParams,
      nzStyle: positionStyle ? positionStyle : {},
      nzMask: modalParams.mask === false ? false : true,
    });

    return modal;
  };
}

interface ModalParams {
  title: string;
  body?: string;
  accentColor?: string;
  icon?: IconDefinition;
  actionPrimaryText?: string;
  actionSecondaryText?: string;
  position?: { top?: number; right?: number; bottom?: number; left?: number };
  mask?: boolean;
  onPrimaryClick?: Function;
  onSecondaryClick?: Function;
  onCancel?: () => void;
}
